import { Flex, Text } from "@scaleaq/sui-react";
import clsx from "clsx";
import type React from "react";
import { useTranslation } from "react-i18next";
import { TRANSLATION } from "src/models/constants";
import styles from "./StatusCard.module.scss";
import type { ColorTokenBackground } from "@scaleaq/sui-react/models/types";

export type StatusCardProps = {
	icon: string | React.ReactNode;
	title?: string;
	subTitle?: string;
	description?: string;
	errorCode?: string;
	color?: ColorTokenBackground;
	className?: string;
	id?: string;
	childrenWithin?: React.ReactNode;
	children?: React.ReactNode;
};

export const StatusCard = (props: StatusCardProps) => {
	const { t } = useTranslation([TRANSLATION.ERROR]);
	const {
		id,
		className,
		icon,
		title = "",
		description = "",
		subTitle,
		errorCode,
		color,
		children,
		childrenWithin,
	} = props;

	const _getTitle = (): string => {
		return errorCode ? (t(`ERROR:status.${errorCode}.title` as any) as string) : title;
	};

	const _getDescription = (): string => {
		return errorCode ? (t(`ERROR:status.${errorCode}.description` as any) as string) : description;
	};

	return (
		<Flex.Column
			id={id}
			className={clsx(styles["status-card"], {
				[`${className}`]: className,
			})}
			alignment="top-left"
		>
			<Flex.Row alignment="top-left" width="100%">
				<Flex.Column
					alignment="top-left"
					className={clsx(styles.left, {
						[styles[`color--${color}`]]: color,
					})}
				>
					{icon}
				</Flex.Column>
				<Flex.Column className={styles.right} alignment="top-left" gap="xlarge">
					<Text.Heading.Medium
						color={"contrast"}
						className={clsx(styles.title, {
							[styles[`color--${color}`]]: color,
						})}
					>
						{_getTitle()}
					</Text.Heading.Medium>
					{subTitle && <Text.Heading.Small color="secondary">{subTitle}</Text.Heading.Small>}
					<Text.Body.Medium size={"large"}>{_getDescription()}</Text.Body.Medium>
					{childrenWithin}
				</Flex.Column>
			</Flex.Row>
			{children && (
				<Flex.Column alignment="top-left" width="100%">
					{children}
				</Flex.Column>
			)}
		</Flex.Column>
	);
};
